import { Konnectable } from 'v2/components/Cell/components/Konnectable'
import Identifiable from 'v2/components/Cell/components/Identifiable'
import Skeletal from 'v2/components/Cell/components/Skeletal'

export default {
  Konnectable,
  Identifiable,
  Skeletal,
}
